import React, { Component, Fragment, type JSX } from 'react';
import { themeFolderPath } from '../../../App';
import { CartListTraining } from '../Checkout.interface';
import { AddOnItem } from './AddOnItem';
import { AddOn } from '../../../models/Article';
import { price } from '../../../util/price.function';

interface CartItemProps {
  id: string;
  title: string;
  subtitle?: string;
  level: string; // required to pass to add-ons
  subject: string; // required to pass to add-ons
  label?: string;
  price: string;
  subItems?: CartListTraining['subItems'];
  upsellItems?: CartListTraining['upsellItems'];
  deleteMethod: (id: string) => Promise<void>;
}

interface CartItemState {
  deleting: boolean;
}

/**
 * Generic cart item which can either be a examentraining
 * or an article like Lyceo Samenvatting. The parent can
 * supply add-ons (which are articles not yet in the cart) or
 * sub-items (which are articles already in the cart)
 *
 * The level and subject for sub-items are determined by
 * the parent training.
 */
export class CartItem extends Component<CartItemProps, CartItemState> {

  public state: CartItemState = {
    deleting: false,
  };

  /**
   * Show the spinner while deleting the cart item.
   * Call the delete method set by the parent component.
   * (Since this item is either a training or article).
   */
  private onRemoveItem(): void {
    this.setState({ deleting: true });
    this.props.deleteMethod(this.props.id);
  }

  public render(): JSX.Element {
    const { id, title, subtitle, label, subject, level, subItems, upsellItems } = this.props;

    // Get list of add-ons in the cart.
    const cartItemSubItems = subItems
      ? subItems.map((item: AddOn) => <AddOnItem
        id={item.id_item}
        idTraining={id}
        key={item.id_item + id}
        subject={subject}
        level={level}
        title={item.title}
        price={item.price}
        tooltip={item.tooltip}
        inCart={true}/>)
      : [];

    // Get list of add-ons not yet in the cart.
    const cartItemUpsellItems = upsellItems
      ? upsellItems.map((item: AddOn) => <AddOnItem
        key={item.id_item + id}
        id={item.id_item}
        idTraining={id}
        subject={subject}
        level={level}
        title={item.title}
        price={item.price}
        tooltip={item.tooltip}
        inCart={false}/>)
      : [];

    return (
      <Fragment>
        <li className="checkout-list__product align-items-center d-flex">
          <div className="checkout-list__product-remove float-right">
            { this.state.deleting
              ? (<i className="fa fa-circle-o-notch fa-spin"/>)
              : (<img onClick={(): void => this.onRemoveItem()}
                src={ `${themeFolderPath}/images/checkout__cross.svg` }
                alt={'remove item'} />)
            }
          </div>
          <div className="checkout-list__cell--left">
            <div className="checkout-list__product-title">
              { title }
            </div>
            <div className="checkout-list__product-subtitle">
              { subtitle }
            </div>
            {label && <span className="checkout-list__label">{ label }</span>}
          </div>
          <div className="checkout-list__cell--right checkout-list__cell--align-text-middle">
            <div className="checkout-list__product-price">
              &euro; { price(this.props.price) }
            </div>
          </div>
        </li>
        { cartItemSubItems }
        { cartItemUpsellItems }
      </Fragment>
    );
  }

}

